import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import { withResizeDetector } from 'react-resize-detector/build/withPolyfill';
import MessagesSection from './messages/MessagesSection.react';
import responsiveness from '../../../../../sass/foundation/variables/responsiveness.scss';

const ReactPropTypes = PropTypes;

class MessagesApp extends React.Component {
  static propTypes = {};
  static defaultProps = {};

  render() {
    const mobile = get(globals, 'responsive', false) && window.innerWidth <= responsiveness.breakpoint;

    return (
      <div className="messages">
        <MessagesSection
          id="private"
          hideHeader
          disableAutoHeight
          dynamicHeight
          maxHeight={99999}
          disableUserLink
          activeMask={this.props.activeMask}
          mobile={mobile}
        />
      </div>
    );
  }
}

module.exports = withResizeDetector(MessagesApp);
